import React from 'react'
import {
  FormControlLabel,
  FormGroup,
  Switch as MUISwitch
} from '@mui/material'

import useStyles from './styles'

const Switch = ({ checked, onChange, className, children }) => {
  const classes = useStyles()

  return (
    <FormGroup className={className}>
      <FormControlLabel
        label={children}
        control={
          <MUISwitch
            checked={checked}
            onChange={e => onChange(e.target.checked)}
            disableRipple
            classes={{
              root: classes.root,
              switchBase: classes.switchBase,
              thumb: classes.thumb,
              track: classes.track,
              checked: classes.checked
            }}
          />
        }
        classes={{
          root: classes.labelRoot,
          label: classes.label
        }}
      />
    </FormGroup>
  )
}

export default Switch
